import React, { useState, useEffect } from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Modal } from '@uhg-abyss/web/ui/Modal';
import PropTypes from 'prop-types';
import { Button } from '@uhg-abyss/web/ui/Button';
import { event } from '@uhg-abyss/web/tools/event';
// import { useRegenerateSecret } from '@src/hooks/useRegenerateSecret';
import { useGenerateSecret } from '@src/hooks/useGenerateSecret';
import { useSelector } from 'react-redux';

const ModalButtons = styled('div', {
  display: 'inline-flex',
  gap: '20px',
});

const ModalText = styled('p', {
  fontSize: '15px',
  color: 'rgb(0, 38, 119)',
});

const RegenerateRequiredError = styled('p', {
  color: 'red',
  fontSize: '15px',
});

export const RegenerateSecretModal = ({
  isOpen,
  closeModal,
  clientId,
  regenerateEnv,
  isProd,
  timeLeft,
  orgId,
}) => {
  const [displayRegenerateError, setDisplayRegenerateError] = useState(false);
  // const [regeneratedSecret, getRegeneratedSecret] = useRegenerateSecret();
  const [generatedSecret, getGeneratedSecret] = useGenerateSecret();
  const userInfo = useSelector((state) => {
    return state.GET_USER_INFO.data;
  });
  const [isLoading, setIsLoading] = useState(false);
  const [hasRegenerated, setHasRegenerated] = useState(false);

  const modalName = 'change API secret key modal pop up';
  const jobName = 'regenerate secret key';
  const generateSecret = () => {
    setHasRegenerated(true);
    const values = { clientId, isProd, orgId };
    getGeneratedSecret({
      variables: { values, regenerateEnv, isSecretGenerated: true },
      userInfo,
    });
  };
  const closeRegenModal = () => {
    setDisplayRegenerateError(false);
    closeModal();
    event('MODAL_CLOSE', {
      event,
      modalName,
    });
    event('JOB_CANCEL', {
      event,
      jobName,
    });
  };
  useEffect(() => {
    if (hasRegenerated) {
      setIsLoading(generatedSecret.loading);
      if (!generatedSecret.loading) {
        if (generatedSecret.error) {
          setDisplayRegenerateError(true);
        } else if (
          generatedSecret.data &&
          Object.keys(generatedSecret.data).length > 0
        ) {
          // getUserStatus({ userInfo, orgId });
          closeModal();
        }
      }
    }
  }, [generatedSecret, hasRegenerated]);

  return (
    <Modal
      size="lg"
      title="You are about to change the API secret."
      isOpen={isOpen}
      onClose={isLoading ? '' : closeRegenModal}
      className="abyss-modal-content-title"
      css={{
        'abyss-modal-content-title': {
          color: 'rgb(0, 38, 119)',
        },
      }}
    >
      <Modal.Section>
        <ModalText>
          You will have to let your users know that the secret has been changed.
          This change will only apply to the secret you have selected; if you
          have a second secret, it will continue to be active until it is
          changed or expired.
        </ModalText>
        {displayRegenerateError && (
          <RegenerateRequiredError>
            The secret regeneration was unsuccessful, please try again.
          </RegenerateRequiredError>
        )}
        <ModalButtons>
          <Button
            variant="outline"
            onClick={closeRegenModal}
            disabled={isLoading}
          >
            Close
          </Button>
          <Button
            isLoading={isLoading}
            ariaLoadingLabel="Regenerating Secret"
            onClick={generateSecret}
            disabled={timeLeft > 0}
          >
            Generate Secret
          </Button>
        </ModalButtons>
      </Modal.Section>
    </Modal>
  );
};

RegenerateSecretModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  clientId: PropTypes.string.isRequired,
  regenerateEnv: PropTypes.string.isRequired,
  isProd: PropTypes.bool.isRequired,
  timeLeft: PropTypes.number.isRequired,
  orgId: PropTypes.string.isRequired,
};
